import React, { useState } from 'react';
import { useInternetStatus } from '../contexts/InternetStatusContext';
import { motion, AnimatePresence } from 'framer-motion'; // Assuming framer-motion is installed for smooth animations
import './InternetStatusIndicator.css';

const InternetStatusIndicator = () => {
  const { isOnline, showStatus } = useInternetStatus();
  const [isDismissed, setIsDismissed] = useState(false);

  if (!showStatus || isDismissed) return null;

  const handleDismiss = () => {
    setIsDismissed(true);
  };

  const handleRetry = () => {
    // Trigger a retry by reloading the page or dispatching a custom event to the context
    window.location.reload(); // Simple retry; customize based on your context if needed
  };

  return (
    <AnimatePresence>
      <motion.div
        className={`internet-status ${isOnline ? 'online' : 'offline'}`}
        initial={{ opacity: 0, y: -50, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -50, scale: 0.95 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
      >
        <motion.div 
          className="status-content"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <motion.span 
            className="status-icon"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1, type: 'spring', stiffness: 300 }}
          >
            {isOnline ? '🌐' : '📡'} {/* Modern icons: globe for online, signal for offline */}
          </motion.span>
          <motion.span 
            className="status-text"
            initial={{ x: -20 }}
            animate={{ x: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
          >
            {isOnline ? 'You’re back online!' : 'You’ve lost your internet connection. Reconnecting...'} {/* Concise, friendly text */}
          </motion.span>
          <motion.button
            className={`action-button ${isOnline ? 'hide' : ''}`}
            onClick={handleRetry}
            whileHover={{ scale: 1.05, backgroundColor: '#4f46e5' }} // Interactive hover
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            Retry
          </motion.button>
          <motion.button
            className="dismiss-button"
            onClick={handleDismiss}
            whileHover={{ rotate: 90 }} // Fun interactive spin on hover
            whileTap={{ scale: 0.9 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            × {/* Close icon */}
          </motion.button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default InternetStatusIndicator;